import { Directive, ElementRef, HostListener, Self, Input, Output, EventEmitter, Optional } from '@angular/core';
import { MatCheckbox, TransitionCheckState } from '@angular/material/checkbox';
import { IconCheckboxComponent } from 'app/shared/icon-checkbox/icon-checkbox.component';
import { NgModel } from '@angular/forms';

@Directive({
  selector: 'mat-checkbox[appInsteadOfModelChange], app-icon-checkbox[appInsteadOfModelChange]'
})
export class InsteadOfCheckboxModelChangeDirective {
  @Output() appInsteadOfModelChange = new EventEmitter<boolean>();

  element: MatCheckbox;

  constructor( @Optional() element?: MatCheckbox, @Optional() element2?: IconCheckboxComponent) {
    this.element = element || element2;

    if (!this.element) {
      throw new Error('InsteadOfCheckboxModelChangeDirective constructor needs to be used either on MatCheckbox, ' +
        'on IconCheckboxComponent. Both are null');
    }

    this.element._onInputClick = _onInputClick;

    const onViewModelChange = this.appInsteadOfModelChange;

    function _onInputClick() {
      if (!this.disabled) {
        onViewModelChange.emit(!this.checked);
      }
    }
  }
}


